import { getToken } from '@/helpers/auth';
import { useQuery } from '@tanstack/react-query';

import { ICategory } from '@/models';
import useQueryParams from '../useQueryParams';
import { fetchProducts } from '@/fetchers/products';
import { groupProductsByCategory } from '@/helpers/products';
import { getLangCountry } from '@/helpers/languages';
import { omit } from 'lodash';

export function useProducts({ category }: { category: ICategory }) {
  const token = getToken();
  const [query] = useQueryParams();

  return useQuery(['products', category, query], async () => {
    const params = omit(query, ['lang', 'country', 'categories', 'sort']);
    const { products, count } = await fetchProducts({
      ...params,
      ...getLangCountry(query),
      token,
      order: query.sort,
      category: (query.categories as string[]).join('/')
    });

    return {
      count,
      products: groupProductsByCategory(products, category)
    };
  });
}
